import index from "./locTypeJournal.vue";
export default index;
